module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAdCAYAAABFRCf7AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAYdEVYdFNvZnR3YXJlAHBhaW50Lm5ldCA0LjAuOWwzfk4AAACQSURBVEhL7ZYxDoAgDEU5F5fhBs7s3opDOTm41UIYalMQSNXEQPJCgd/HRjDGeYsERWyUBgAwWiTxJ1I8Bw7PUPC8Li0JauL3pLGhF9Z/lfJAK7RPlI5SlGogStmtXXVeT+mUsk2cxuq8ntJfSFu4labh/BYnGqyB+Z3mS9IFORDxMRZYY1tRqsGjUuW/lLcnOgb2GZ1vBQUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/component/Asset/gallery/trashcan_icon.png
// module id = 710
// module chunks = 0